import { createHttpEndpoint } from '../utils'

import type { RatingDistribution } from './types/distributions'
import type { GetReviewsListResponse } from './types/list'
import type { Rating } from './types/rating'
import type { ReviewRatingsSummary } from './types/review'

/**
 * List of customer reviews for a specific seller
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/review-service-api/definition#tag/seller/operation/get-reviews-seller-id-reviews}
 */
export const getReviews = createHttpEndpoint<GetReviewsListResponse>({
  method: 'GET',
  operationId: 'fetchReviewsListBySeller',
  path: '/reviews/v1/sellers/:uuid/products/reviews',
})

/**
 * Review summary (average rate & number of reviews) for a specific seller
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/review-service-api/definition#tag/seller/operation/get-reviews-sellers-id-reviews-summary}
 */
export const getRating = createHttpEndpoint<Rating>({
  method: 'GET',
  operationId: 'fetchRatingSummaryBySeller',
  path: '/reviews/v1/sellers/:uuid/products/reviews-summary',
})

/**
 * Distribution of ratings for a specific seller
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/review-service-api/definition#tag/seller/operation/get-reviews-sellers-id-distributions}
 */
export const getRatingDistribution = createHttpEndpoint<RatingDistribution[]>({
  method: 'GET',
  operationId: 'fetchRatingDistributionBySeller',
  path: '/reviews/v1/sellers/:uuid/products/reviews/distributions',
})

/**
 * Average rate of each rating details (battery, shipping, ...) for a specific seller
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/review-service-api/definition#tag/seller/operation/get-reviews-sellers-id-details-summary}
 */
export const getRatingDetailsSummary = createHttpEndpoint<ReviewRatingsSummary>(
  {
    method: 'GET',
    operationId: 'fetchRatingDetailsSummaryBySeller',
    path: '/reviews/v1/sellers/:uuid/products/reviews/details-summary',
  },
)
